import { createContext, useContext } from "react";

import type { CarouselInternals } from "../types";

const CarouselContext = createContext<CarouselInternals>(null);
const useCarouselContext = (): CarouselInternals => useContext(CarouselContext);

export { CarouselContext, useCarouselContext };
